var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}],staticClass:"alert-modal-container"},[_c('div',{staticClass:"alert-modal-box"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }